import { createAsyncThunk } from "@reduxjs/toolkit";
import { ReducerEntityPrefixTypes, ReducerNamespaceTypes } from "enums";
import dataService from "features/Application/services/dataServices/dataService";
import { unionBy } from "lodash";

export interface GroupOptionParams {
  top?: number;
  skip?: number;
  term?: string;
  ids?: string[];
}

export const groupFilterThunk = createAsyncThunk(
  `${ReducerNamespaceTypes.People}/${ReducerEntityPrefixTypes.Users_Groups}/fetchGroupFilters`,
  async (params: GroupOptionParams, { rejectWithValue }) => {
    try {
      const { ids, ...rest } = params || {};

      const searchResult = await dataService.getAccountGroups(rest);

      let selectedResult = [];
      if (ids && ids.length) {
        selectedResult = await dataService.getAccountGroups({ ids });
      }

      const combined = unionBy(searchResult, selectedResult, "id");

      return combined.map((x: any) => ({
        text: x.name,
        value: x.id,
      }));
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);
